import {
  OrganizationContext,
  OrganizationContextProps,
} from '@web-app/hocs/organization';
import {
  getDomainFromWindow,
  getOrganizationConfig,
  getOrganizationIdByOrigin,
} from '@web-app/utils/api/whitelabel/organization-configs';
import { useRouter } from 'next/router';
import { useContext, useMemo } from 'react';

/**
 * Hook to get the current organization's logo configuration
 * Handles special case for sign-in routes where organizationId comes from domain
 *
 * @returns The logo configuration object or null if no organization is found
 */
export const useOrganizationLogo = () => {
  const { organizationId } =
    useContext<OrganizationContextProps>(OrganizationContext);
  const router = useRouter();

  return useMemo(() => {
    const healthieOrgToProceed = router.pathname.includes('/sign-in')
      ? getOrganizationIdByOrigin(getDomainFromWindow())
      : organizationId;

    if (!healthieOrgToProceed) return null;

    const config = getOrganizationConfig(healthieOrgToProceed);
    return config.branding.logos;
  }, [organizationId, router.pathname]);
};
